import UserInfo from './components';

export default UserInfo;
